



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Store } from '@/enums/Store';
import { Locale } from '@/enums/Locale';
import { formatPriceByCurrency } from '@/util/price';
import { Member } from '@/util/Member';
import { Event } from '@/util/Event';
import { namespace } from 'vuex-class';
import MemberOverview from '@/components/Overview/Member/MemberOverview.vue';
import { Currency } from '@/enums/Currency';

const MEMBER = namespace(Store.MEMBER);
const CART = namespace(Store.CART);
const EVENT = namespace(Store.EVENT);
const APP = namespace(Store.APP);

@Component({
  components: { MemberOverview }
})
export default class MemberList extends Vue {
  @Prop({ default: true }) showMemberButtons!: boolean;
  @APP.State('locale') locale!: Locale;
  @APP.State('currency') currency!: Currency;
  @MEMBER.State('members') members!: Member[];
  @MEMBER.Action('addMember') pushMember!: (member: Member) => void;
  @CART.Getter('total') total!: number;
  @EVENT.Getter('selectedEventObject') event!: Event;

  addMember() {
    const ticketCategory = this.event.ticketCategories[0];
    const member = Member.create(ticketCategory);
    this.pushMember(member);
  }

  get formatedPrice(): string {
    const price = this.total;
    if (!price) {
      return '';
    }

    return formatPriceByCurrency(price, this.currency);
  }
}
